export default __webpack_public_path__ + "static/media/data.416648ee.svg";